/**
 * Sentry initialization — fail-soft. If REACT_APP_SENTRY_DSN is missing,
 * this is a no-op so the app keeps running in dev/preview.
 */
import * as Sentry from '@sentry/react';

let _initialized = false;

export function initSentry() {
  if (_initialized) return;
  const dsn = (process.env.REACT_APP_SENTRY_DSN || '').trim();
  if (!dsn) return;
  try {
    const backend = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
    Sentry.init({
      dsn,
      environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'development',
      release: process.env.REACT_APP_SENTRY_RELEASE || 'frontend@unknown',
      tracesSampleRate: 0.1,
      sendDefaultPii: false,
      integrations: [
        Sentry.browserTracingIntegration({
          tracePropagationTargets: backend ? [backend, /^https?:\/\/localhost/] : [/^https?:\/\/localhost/],
        }),
      ],
      beforeSend(event) {
        try {
          if (event.user && event.user.email) delete event.user.email;
          if (event.request && event.request.headers) {
            const h = event.request.headers;
            for (const k of Object.keys(h)) {
              if (/^(authorization|cookie|x-api-key)$/i.test(k)) h[k] = '[Filtered]';
            }
          }
          if (event.request && typeof event.request.url === 'string' && event.request.url.includes('?')) {
            event.request.url = event.request.url.split('?', 1)[0];
          }
        } catch {/* ignore */}
        return event;
      },
    });
    _initialized = true;
  } catch (e) {
    // Never break the app if Sentry init fails.
    console.warn('[sentry] init failed', e);
  }
}

export function captureException(err, extra) {
  try { Sentry.captureException(err, extra ? { extra } : undefined); } catch {/* ignore */}
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;
